<template>
  <div class="content extended-forms">
    <div class="row">
      <ArtistSelect
        class="col-md-8"
        @memberChangeEvent="getArtistInfo"
        :is-filter="true"
        :include-unit-artist="true"
        :initial-unit-id="$route.query.unitId ? parseInt($route.query.unitId, 10) : null"
        :initial-member-id="$route.query.artistId ? parseInt($route.query.artistId, 10) : null"
      />
      <div class="col-md-4">
        <h4 class="card-title text-left">&nbsp;</h4>
        <div class="row">
          <base-button class="col-md-12" @click="showModal" type="success">가중치설정</base-button>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-3" v-for="(item, index) in list">
        <CardLayout
          :key="index"
          :contentId="item.collectionId"
          :fileIds="item.fileIds"
          :title="item.title"
          :state="item.state"
          :viewCount="item.viewCount"
          :commentCount="item.commentCount"
          :likeCount="item.likeCount"
          :pinCount="item.pinCount"
          :regDate="item.regTime"
          :btnDelete="true"
          :btnDetail="true"
          @contentDetail="goCollectionDetail"
          @deleteContent="deleteCollection"
        />
      </div>
    </div>
    <CollectionPoolModal :key="componentKey" :onCancel="onCancelModal" :onConfirm="onCollectionModal" :shouldShow="collectionModal.show"></CollectionPoolModal>
  </div>
</template>
<script>
import ArtistSelect from "@/pages/Components/ArtistSelect.vue";
import CardLayout from "@/pages/Components/CardLayout.vue";
import CollectionPoolModal from "./CollectionPoolModal.vue";
import swal from "sweetalert2";
import { URLUtils } from "@/util/URLUtils";
import { formatDateTime } from "@/util/DateUtils";

export default {
  name: "CollectionPool",
  components: {
    ArtistSelect,
    CardLayout,
    CollectionPoolModal,
  },
  async created() {},
  data() {
    return {
      componentKey: 0,
      collectionModal: {
        show: false,
      },
      searchPeriod: [],
      list: [],
      hotList: [],
      currentPage: 1,
      totalPages: 1,
      unitId: null,
      memberId: null,
    };
  },
  methods: {
    async getArtistInfo(param) {
      this.unitId = param.unitId;
      this.memberId = param.memberId;
      await this.getCollections();
    },
    async getCollections() {
      const queryParams = {
        unitId: this.unitId,
        artistId: this.memberId || undefined,
      };

      const url = "/collection/hotCollections";

      const params = { unitId: this.unitId, artistId: this.memberId };

      const path = `/collection/collectionPool?${URLUtils.objectToQueryString(queryParams)}`;
      if (this.$route.fullPath !== path) {
        try {
          await this.$router.push(path);
        } catch (ex) {}
      }
      return this.$axios
        .get(url, {
          params,
        })
        .then((res) => {
          this.list = res.data.data.data.map((d) => {
            d.regTime = formatDateTime(d.regTime);
            return d;
          });
          for (let i = 0; i < this.list.length; i++) {
            this.list[i].fileIds = [this.list[i].coverFileId];
            for (let j = 0; j < this.list[i].medias.length; j++) {
              this.list[i].fileIds.push(this.list[i].medias[j].fileId);
            }
          }
        });
    },

    async deleteCollection(param) {
      swal
        .fire({
          title: "삭제 확인",
          text: `${param.title} 갤러리을 인기갤러리풀에서 삭제하시겠습니까?(영구삭제)`,
          type: "warning",
          showCancelButton: true,
          customClass: {
            confirmButton: "btn btn-danger btn-fill",
            cancelButton: "btn btn-cancel btn-fill",
          },
          confirmButtonText: "삭제",
          cancelButtonText: "취소",
          buttonsStyling: false,
        })
        .then(async (selection) => {
          if (selection.value) {
            try {
              const contentId = param.contentId;
              return this.$axios
                .delete(`/collection/${contentId}/hotCollection`, {
                  params: { unitId: this.unitId },
                })
                .then((res) => {
                  Toast.success("인기갤러리 삭제 되었습니다");
                  this.getCollections();
                });
            } catch (err) {
              Toast.error("인기갤러리 삭제 중 에러가 발생하였습니다.");
            }
          }
        });
    },
    showModal() {
      this.collectionModal.show = true;
    },
    onCollectionModal() {},
    onCancelModal() {
      this.collectionModal.show = false;
    },

    goCollectionDetail(param) {
      this.$router.push(`/collection/collectionDetail?collectionId=${param.contentId}&unitId=${this.unitId}`);
    },
  },
};
</script>
<style scoped lang="scss">
.content {
  .row {
    margin-bottom: 20px;
  }
}
</style>
